module.exports = __webpack_public_path__ + "static/media/chat-blue-icon.5402eeec.svg";